import type { RouteRecordRaw } from "vue-router";

export const pinboardRoutes: RouteRecordRaw[] = [
  {
    path: "/pinboard/info",
    name: "pinboard-info",
    component: () => import("./info/PinboardInfoPage.vue"),
    meta: {
      namespace: "pinboard",
    },
  },
  {
    path: "/pinboard/boards",
    name: "pinboard-index",
    component: () => import("./boards/BoardListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "pinboard",
      title: "tools_meta.pinboard_prefix",
    },
  },
  // Parent layout - passes item prop to children via RouterView
  {
    path: "/pinboard/boards/:id",
    name: "pinboard-show",
    component: () => import("./boards/BoardLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "pinboard",
      title: "tools_meta.pinboard_prefix",
    },
    children: [
      {
        path: "activities",
        name: "pinboard-activities",
        component: () =>
          import("./boards/[id]/activities/BoardActivityListPage.vue"),
        meta: {
          title: "tools_meta.pinboard_prefix",
        },
      },
      {
        path: "cards/:cardId",
        name: "pinboard-card-show",
        component: () =>
          import("./boards/[id]/cards/[cardId]/BoardCardDetailPage.vue"),
        meta: {
          title: "tools_meta.pinboard_prefix",
        },
      },
      {
        path: "members",
        name: "pinboard-members",
        component: () =>
          import("./boards/[id]/members/BoardMemberListPage.vue"),
        meta: {
          title: "tools_meta.pinboard_prefix",
        },
      },
      {
        path: "settings",
        name: "pinboard-settings",
        component: () => import("./boards/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "pinboard",
          title: "tools_meta.pinboard_prefix",
        },
      },
      {
        path: "share",
        name: "pinboard-share",
        component: () => import("./boards/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "pinboard",
          title: "tools_meta.pinboard_prefix",
        },
      },
      {
        path: "theming",
        name: "pinboard-theming",
        component: () => import("./boards/[id]/theming/BoardThemingPage.vue"),
        meta: {
          title: "tools_meta.pinboard_prefix",
        },
      },
    ],
  },
  // Public boards - also need nesting
  {
    path: "/pinboard/public_boards/:id",
    name: "public-pinboard-show",
    component: () => import("./public_boards/PublicBoardLayout.vue"),
    meta: {
      namespace: "pinboard",
      public: true,
    },
    children: [
      {
        path: "activities",
        name: "public-pinboard-activities",
        component: () =>
          import("./public_boards/[id]/activities/PublicBoardActivityListPage.vue"),
        meta: {
          public: true,
        },
      },
      {
        path: "cards/:cardId",
        name: "public-pinboard-card-show",
        component: () =>
          import("./public_boards/[id]/cards/[cardId]/PublicBoardCardDetailPage.vue"),
        meta: {
          public: true,
        },
      },
    ],
  },
];
